import React from 'react';
import { TableHead } from './ui/table';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

/**
 * Sortable table column header. Click to toggle asc → desc → asc.
 * @param {Object} props
 * @param {string} props.field - Sort field key
 * @param {string} props.currentSort - Currently active sort field
 * @param {'asc'|'desc'} props.currentDir - Current sort direction
 * @param {function} props.onSort - Callback(field) to toggle sort
 * @param {string} [props.className] - Extra className for TableHead
 * @param {React.ReactNode} props.children - Column label
 */
export const SortableTableHead = ({ field, currentSort, currentDir, onSort, className, children }) => {
  const isActive = currentSort === field;
  return (
    <TableHead
      className={`cursor-pointer select-none ${className || ''}`}
      onClick={() => onSort(field)}
      data-testid={`sort-header-${field}`}
    >
      <span className="inline-flex items-center gap-1">
        {children}
        {isActive ? (
          currentDir === 'asc'
            ? <ArrowUp className="w-3.5 h-3.5 text-[#2563eb]" />
            : <ArrowDown className="w-3.5 h-3.5 text-[#2563eb]" />
        ) : (
          <ArrowUpDown className="w-3.5 h-3.5 text-muted-foreground/40" />
        )}
      </span>
    </TableHead>
  );
};
